import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <g clipPath="url(#clip0_2616_206)">
        <path
          fill="#BFC2C3"
          d="M7 .875A6.124 6.124 0 0113.125 7 6.122 6.122 0 017 13.125 6.122 6.122 0 01.875 7 6.124 6.124 0 017 .875zm.765 8.423h-1.53v1.53h1.53v-1.53zm0-6.125h-1.53v4.592h1.53V3.173z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2616_206">
          <path fill="#fff" d="M0 0H14V14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
